
import './App.css';
import VideoHotSpot from './VideoHotSpot';

function App() {
  return (
    <VideoHotSpot/>
  );
}

export default App;
